import React, { useEffect, useState, useRef  } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import {BrowserRouter as Router, Routes, Route, Navigate, Link} from 'react-router-dom';
import {Container,Box, Typography, AppBar, Toolbar, Button,Accordion, AccordionSummary, AccordionDetails} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import kakaoImage from './images/kakao.png';
import NaverImage from './images/naver.png';
import MainImagePC from './images/main_pc.jpg';
import MainImageMobile from './images/main_mobile.jpg';
import semuImage from './images/semu.png';

/* =====================
   공통 상수
===================== */
const fontSize_text_intro = '22px';
const fontSize_FAQs = '21px';
const color_navigator = 'rgb(11, 49, 82)';
const color_box = '#EBF9FF';
const color_text_question = 'rgba(67, 67, 67, 1)';
const font_FAQ_panel = { fontSize: '20px', lineHeight: 1.6 };

const link_kakao_chat = 'http://pf.kakao.com/_xcCvxin';
const link_naver_blog = 'https://blog.naver.com/ju5606';
const link_naver_place = 'https://map.naver.com/p/entry/place/2011570625';

const com_name = "지지종합클린"
const com_phone = "010-9019-5183"
const com_email= "ju5606@naver.com"

const font_toolbar = {
  fontSize: { xs: '15px', md: '21px' },
  fontWeight: 600,
  color: '#fff',
};
const public_email_key = "NorIVYWpq7P0Yhu-s";
const EMAILJS_SERVICE_ID = 'service_fieakqu';
const EMAILJS_TEMPLATE_ID = 'template_spwp72p';
const inputStyle = {
  width: '100%',
  padding: '12px',
  marginBottom: '12px',
  fontSize: '14px',
  borderRadius: '6px',
  border: '1px solid #ddd',
  boxSizing: 'border-box',
};

// FAQ 데이터 한번에 관리
const FAQ_DATA = {
  // 청소 서비스 FAQ
  text_cleaning: [
    { 
      question: "다른 지역도 에어컨청소가 가능한가요?", 
      answer: (
        <>
          <b>고객님의 소중한 문의는 언제든 환영합니다.</b><br />
          <b>대전·세종·청주를 중심으로 그외 지역까지  
          에어컨 분해청소 출동이 가능합니다.</b><br /><br />
          거리나 지역에 따라 일정 조율만 필요할 뿐,  
          청소 품질이나 작업 방식에는 차이가 없습니다.<br />
          <b>편하게 문의 주시면 정확한 가능 지역과 일정 안내드리겠습니다.</b>
        </>
      )
    },
    { 
      question: "에어컨청소만 단독으로 맡겨도 되나요?", 
      answer: (
        <>
          고객님의 소중한 문의는 언제든 환영합니다.<br />
          <b>에어컨 분해청소는 단독 진행</b>이 가능하며,  <br />
          벽걸이·스탠드·천장형(시스템) 등 모든 유형 작업이 가능합니다.<br /><br />
          사용 환경과 오염 상태에 따라  
          맞춤 세척 방식으로 진행됩니다.<br />
          <b>여러 대 동시 진행 시 비용 절감 및 일정 효율이 가능합니다.</b>
        </>
      )
    },
    { 
      question: "에어컨청소는 언제 하는 게 좋나요?", 
      answer: (
        <>
          <b>에어컨 사용 전·후 시점에 청소를 진행하는 것이 가장 효과적입니다.</b><br />
          특히 여름철 사용 전에는 내부 곰팡이와 먼지를 제거해  
          쾌적한 바람을 유지하는 것이 중요합니다.<br /><br />
          <b>* 냄새가 나는 경우</b><br />
          <b>* 바람이 약해졌다고 느껴질 경우</b><br />
          <b>* 장기간 청소를 하지 않은 경우</b><br /><br />
          위와 같은 상황이라면 즉시 점검 및 청소를 권장드립니다.<br />
          <b style={{ color: 'red', fontSize: '19px' }}>여름철 성수기에는 예약이 몰려</b><br />
          <b style={{ color: 'red', fontSize: '19px' }}>원하시는 일정에 작업이 어려운 경우가 많습니다.</b><br />
          <b style={{ color: 'red', fontSize: '19px' }}>미리 점검 및 청소를 진행하시는 것을 추천드립니다.</b>
        </>
      )
    },
    {
    question: "완전 분해청소는 어떤 방식으로 진행되나요?", 
    answer: (
        <>
          네, 에어컨청소는 단순한 외부 세척이 아닌<br />
          <b>완전 분해 후 내부까지 세척하는 작업</b>이 핵심입니다.<br />
          겉으로 보이는 필터 청소만으로는<br />
          냄새와 오염의 원인을 해결할 수 없습니다.<br /><br />

          먼저 전원 차단 후 외부 커버와 필터를 분리하고,<br />  
          내부 열교환기, 송풍팬(팬블레이드), 드레인(배수라인)까지<br /> 
          <b>구조에 맞춰 단계별로 분해 작업을 진행합니다.</b><br /><br />

          이후 고압세척기와 전용 세척 약품을 사용하여<br />  
          눈에 보이지 않는 곰팡이, 세균, 미세먼지, 찌든 때까지<br />  
          <b>근본적인 오염 원인을 제거합니다.</b><br />
          특히 송풍팬과 드레인에 쌓인 오염은<br />  
          악취의 주요 원인이기 때문에 꼼꼼한 세척이 중요합니다.<br /><br />

          세척 후에는 충분한 건조 과정을 거친 뒤<br />  
          분해했던 부품을 정확하게 재조립하고,<br />  
          <b>누수 여부, 냉방 성능, 작동 상태까지 최종 점검</b>을 진행합니다.<br /><br />

          단순히 깨끗해 보이게 하는 작업이 아니라<br />  
          <b>실내 공기 질 개선과 냉방 효율 향상까지 고려한 전문 작업</b>이며,<br />
          정기적인 분해청소를 통해 기기 수명 연장과 전기요금 절감에도 도움이 됩니다.<br />
        </>
      )
    },
    {
      question: "에어컨청소 소요 시간은 얼마나 걸리나요?",
      answer: (
        <>
          에어컨 종류와 오염 상태에 따라 작업 시간은 달라집니다.<br />
          일반적으로<br />
          <b>벽걸이 약 2시간, 스탠드 약 2~3시간, 천장형(시스템)은 4시간 정도</b> 소요됩니다.<br />
          (신속한 처리가 필요하신 경우에는 별도 말씀 주시면 좋습니다)<br /><br />

          다만 오염이 심하거나 여러 대를 동시에 진행하는 경우<br />
          작업 시간이 추가될 수 있습니다.<br />
          <b>사전 상담 시 예상 소요 시간과 작업 범위를 정확하게 안내드립니다.</b><br /><br />

          최대한 신속하면서도 꼼꼼한 작업으로<br />  
          <b>시간과 품질 모두 만족하실 수 있도록 진행합니다.</b>
        </>
      )
    }
  ]
};

// FAQ 함수 공통관리
function FAQ({ type }) {
  const [expanded, setExpanded] = useState(false);
  const summaryRefs = useRef([]);
  const HEADER_OFFSET = 70; // 상단 고정 헤더 높이

  const handleChange = (idx) => (_, isExpanded) => {
    setExpanded(isExpanded ? idx : false);
  };

  const faqList =
    type === 'main'
      ? [...FAQ_DATA.freelancer, ...FAQ_DATA.individual, ...FAQ_DATA.corporate]
      : FAQ_DATA[type] || [];

  return (
    <Box sx={{ backgroundColor: '#F8FAFC', py: 6 }}>
      <Container>
        <Typography variant="h4" sx={{ mb: 4, textAlign: 'center' }}>
          자주 묻는 질문
        </Typography>

        {faqList.map((item, idx) => (
          <Accordion
            key={idx}
            expanded={expanded === idx}
            onChange={handleChange(idx)}
            TransitionProps={{
              timeout: 200,
              onEntered: () => {
                summaryRefs.current[idx]?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              ref={(el) => (summaryRefs.current[idx] = el)}
              sx={{
                scrollMarginTop: "80px",
              }}
            >
              <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>
                {item.question}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography sx={{ fontSize: '18px', lineHeight: 1.6 }}>
                {item.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}

const pageData = {
  text_cleaning: {
    title: `대전·세종·청주 전역 에어컨 청소 전문 공간·업종 맞춤 분해 세척 서비스`,
    intro: `🔹 주말/공휴일 상시 상담 🔹
  원룸 벽걸이부터 스탠드·시스템 에어컨까지
가정용·상업용 에어컨 분해 세척을 전문적으로 진행합니다.
카페·병원·학원·사무실 등 다양한 업종 경험으로
오염 상태에 맞는 최적의 세척을 제공합니다.

무료 상담 및 사진 견적으로 합리적인 비용을 안내드리며,
문의주시면 결과로 보답드리겠습니다.

에어컨은 겉만 닦는다고 해결되지 않습니다.
내부 열교환기, 팬, 드레인까지
보이지 않는 곳의 곰팡이와 세균 제거가 핵심입니다.
맡겨만 주세요.
확실한 분해 세척으로 쾌적한 바람을 만들어드립니다.`,

    stepsTitle: "에어컨 청소는 이렇게 진행됩니다",
    steps: [
      "전화·문자·카카오톡 등을 통한 간편 상담",
      "에어컨 종류(벽걸이·스탠드·시스템) 및 수량 확인",
      "사용 환경 및 오염 상태에 따른 작업 범위 안내",
      "전문 장비 및 전용 세척 약품 사전 준비",
      "에어컨 완전 분해 후 내부 고압 세척 진행",
      "건조 및 재조립 후 정상 작동 여부 확인",
    ],
    highlight:
      "에어컨 청소는 단순한 관리가 아니라\n내 '식구'의 건강과 직결된 작업입니다.\n곰팡이, 세균, 악취를 방치하면\n호흡기 문제와 실내 공기 질 저하로 이어질 수 있습니다.\n에어컨 전문 분해 세척을 통해 쾌적함은 물론,\n전기 효율과 기기 수명까지 함께 관리하는 것이 중요합니다.",

    buttonText: "청소 상담 문의하기",

    // 🔽 추가 보완 영역
    industryPoints: {
      wall: {
        title: "벽걸이 에어컨 청소",
        points: [
          "가정용에서 가장 많이 사용되는 유형으로 내부 곰팡이 발생이 잦습니다.",
          "전면 커버 및 필터 분리 후 열교환기·송풍팬 중심으로 분해 세척을 진행합니다.",
          "구조가 비교적 단순하지만, 팬 오염 시 냄새의 원인이 되기 때문에 꼼꼼한 세척이 중요합니다.",
          "소형 공간(원룸·오피스텔 등)에 적합하며 정기적인 관리가 필요합니다.",
          "비교적 작업 시간이 짧고 비용 효율적인 청소가 가능합니다."
        ]
      },
      stand: {
        title: "스탠드 에어컨 청소",
        points: [
          "거실 및 상업공간에서 사용되며 풍량이 강해 내부 오염도 빠르게 쌓입니다.",
          "외부 패널 분해 후 내부 열교환기, 팬, 드레인까지 전체 분해 세척을 진행합니다.",
          "하단부 물받이 및 배수라인 오염이 냄새의 주요 원인이 됩니다.",
          "높이와 구조상 분해 난이도가 있어 전문 장비와 숙련도가 중요합니다.",
          "냉방 효율과 직결되기 때문에 정기적인 관리가 필수입니다."
        ]
      },
      system: {
        title: "천장형(시스템) 에어컨 청소",
        points: [
          "사무실, 카페, 병원 등에서 사용되는 매립형 구조로 오염 확인이 어렵습니다.",
          "천장 패널 탈거 후 내부 팬, 열교환기, 드레인까지 완전 분해 세척을 진행합니다.",
          "배수펌프 및 드레인 막힘 시 누수 문제가 발생할 수 있어 점검이 중요합니다.",
          "여러 대가 동시에 설치된 경우가 많아 일정 및 작업 동선 계획이 필요합니다.",
          "고소 작업이 포함되므로 안전 장비 및 전문 인력 투입이 필수입니다."
        ]
      }
    }
  }
};


// 이메일함수
function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    industry: '',
    businessType: '',
  });

  const [isSending, setIsSending] = useState(false);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSending) return; // 중복 클릭 방지
    setIsSending(true);

    emailjs
      .send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: form.name,
          phone: form.phone,
          industry: form.industry,
          businessType: form.businessType,
        }
      )
      .then(() => {
        alert('상담 신청이 접수되었습니다.');
        setForm({ name: '', phone: '', industry: '', businessType: '',  etc : ''});
      })
      .catch(() => {
        alert('전송에 실패했습니다. 다시 시도해주세요.');
      })
      .finally(() => {
        setIsSending(false); // ✅ 성공/실패 상관없이 원복
      });
  };

  return (
    <Box
      sx={{
        mt: 8,
        p: 4,
        backgroundColor: '#F8FAFF',
        borderRadius: 2,
        width: '70%',
        mx: 'auto',
      }}
    >
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 700, textAlign: 'center' }}
      >
        간편 상담 신청
      </Typography>

        <form
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            // textarea에서는 엔터 허용
            if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
              e.preventDefault();
            }
          }}
        >
        {/* 성함 */}
        <input
          name="name"
          placeholder="상호 or 성함"
          value={form.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        {/* 연락처 */}
        <input
          name="phone"
          placeholder="연락처"
          value={form.phone}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        {/* 업종 */}
        <input
          name="industry"
          placeholder="지역·업무 (예: 둔산 벽걸이 2대 / 청주 스탠드 9대)"
          value={form.industry}
          onChange={handleChange}
          style={inputStyle}
        />

        {/* 사업형태 */}
        <input
          name="businessType"
          placeholder="기타요청사항(선택)"
          value={form.businessType}
          onChange={handleChange}
          style={inputStyle}
        />

        {/* 상담신청보내기 버튼 */}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={isSending}
          sx={{
            mt: 2,
            py: 1.6,
            fontWeight: 700,
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
            opacity: isSending ? 0.7 : 1,
          }}
        >
          {isSending ? '전송중...' : '상담 신청 보내기'}
        </Button>
      </form>

      {/* 하단 안내 문구 */}
      <Typography
        sx={{
          mt: 2,
          fontSize: 13,
          color: '#666',
          textAlign: 'center',
          lineHeight: 1.5,
        }}
      >
        담당자에게 자료가 전송됩니다.<br />
        신속히 연락드리겠습니다.
      </Typography>
    </Box>
  );
}


function TaxPage({ type }) {
  const data = pageData[type];
  if (!data) return null;

  return (
    <Container sx={{ mt: 6, mb: 8, backgroundColor: '#FDFDFD', borderRadius: 2, p: { xs: 2, md: 4 } }}>
      {/* 타이틀 */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: 3,
          color: '#373b44', // 진한 네이비
          fontSize: { xs: '1.6rem', sm: '2rem', md: '2.25rem' },
        }}
      >
        {data.title}
      </Typography>
      
      {/* 소개 */}
      <Typography
        sx={{
          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.125rem' },
          lineHeight: 1.9,
          mb: 5,
          color: '#14532D', // 다크 그레이
          whiteSpace: 'pre-line',
        }}
      >
        {data.intro}
      </Typography>
      {/* 🎥 상단 소개 영상 */}
      <Box
        sx={{
          width: '100%',
          maxWidth: { xs: 420, md: '100%' }, 
          aspectRatio: { xs: '5 / 7', md: '16 / 9' }, // PC는 가로 영상 느낌
          backgroundColor: 'black',
          mx: 'auto',
          mb: 4,
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        <Box
          component="video"
          src="/videos/clean_video1.mp4"
          autoPlay
          muted
          loop
          playsInline
          poster="/images/clean.jpg"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: { xs: 'contain', md: 'cover' }, // PC는 꽉 채우기
            display: 'block',
          }}
        />
      </Box>

      {/* 단계별 대응 */}
      <Box sx={{ mb: 5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1E3A8A' }}>
          {data.stepsTitle}
        </Typography>
        <ul style={{ color: '#555555', lineHeight: 1.8 }}>
          {data.steps.map((step, idx) => (
            <li key={idx}>
              {step.split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </li>
          ))}
        </ul>
      </Box>

      <ContactForm />

      {/* 청소 유형별 체크 포인트! */}
      {data.industryPoints && (
        <Box sx={{ mt: 6, mb: 6 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: 4,
              color: '#373b44',
              fontSize: { xs: '1.3rem', sm: '1.5rem' },
            }}
          >
            청소 유형별 체크 포인트
          </Typography>

          {Object.values(data.industryPoints).map((industry, idx) => (
            <Box
              key={idx}
              sx={{
                mb: 4,
                p: { xs: 2, md: 3 },
                borderRadius: 2,
                backgroundColor: '#F8FAFF',
                border: '1px solid #E2E8F0',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  color: '#1E3A8A',
                }}
              >
                {industry.title}
              </Typography>

              <ul style={{ paddingLeft: '18px', lineHeight: 1.9, color: '#444' }}>
                {industry.points.map((point, pIdx) => (
                  <li key={pIdx}>{point}</li>
                ))}
              </ul>
            </Box>
          ))}
        </Box>
      )}

      {/* 강조 박스 */}
      <Box sx={{ backgroundColor: '#E8F0FE', p: 3, borderRadius: 2, mb: 5 }}>
        <Typography sx={{ fontSize: '1rem', lineHeight: 1.8, color: '#1E3A8A', whiteSpace: 'pre-line' }}>
          {data.highlight}
        </Typography>
      </Box>


      {/* FAQ */}
      <FAQ type={type} />
    </Container>
  );
}


// 지도 / 이미지
function Whereweare() {
  return (
    <Container sx={{ my: 4, textAlign: 'center' }}>

      {/* 제목 */}
      <Typography variant="h4">
        에어컨 청소는 지지종합클린
      </Typography>

      {/* 제목 아래 버튼 */}
      <Button
        variant="contained"
        color="primary"
        href={link_naver_place}
        target="_blank"
        sx={{
          mt: 2,                // 제목과 간격
          fontSize: '1.25rem',
          padding: '12px 24px',
          minWidth: '200px',
          minHeight: '48px',
          borderRadius: '12px',
        }}
      >
        네이버 지도 확인
      </Button>

      {/* 지도 이미지 */}
      <Box sx={{ mt: 4 }}>
        <img
          src={semuImage}
          alt="지도"
          style={{ width: '100%', maxWidth: '900px' }}
        />
      </Box>

    </Container>
  );
}


// 고정 컴포넌트(카카오, 블로그, 푸터)
function KakaoLink() {
  return (
    <Box sx={{
      position: 'fixed', bottom: 16, right: 16, zIndex: 1000, cursor: 'pointer',
      '@media (max-width: 768px)': { bottom: 70 }, // 작은 화면에서 위로 배치
      '@media (min-width: 769px)': { bottom: 80 }, // 큰 화면에서 아래로 배치
    }}
      onClick={() => window.open(link_kakao_chat, '_blank')}>
      <img src={kakaoImage} alt="카카오톡 상담" width="50" height="50" style={{ borderRadius: '50%', boxShadow: '0px 4px 8px rgba(0,0,0,0.2)' }}/>
    </Box>
  );
}
function NaverLink() {  
  return (    
    <Box sx={{
      position: 'fixed', bottom: 16, right: 16, zIndex: 1000, cursor: 'pointer',
      '@media (max-width: 768px)': { bottom: 130 }, // 작은 화면에서 아래로 배치
      '@media (min-width: 769px)': { bottom: 150 }, // 큰 화면에서 아래로 배치
    }}
      onClick={() => window.open(link_naver_blog, '_blank')}    >
      <img src={NaverImage} alt="네이버블로그" width="50" height="50" style={{ borderRadius: '50%', boxShadow: '0px 4px 8px rgba(0,0,0,0.2)' }} />
    </Box>
  );
}
function Footer() {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: color_navigator,
        color: '#fff',
        padding: '10px 0', // 위아래 균일한 여백
        textAlign: 'center',
        boxShadow: '0px -2px 4px rgba(0,0,0,0.2)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '1.5',
          margin: 0, // 기본 마진 제거
          display: 'inline-block', // 텍스트를 블록 컨테이너로
        }}ㅊ
      >
        © {com_name} <span style={{ margin: '0 15px' }}>|</span> 
        문의: <a href="tel:01090195183" style={{ color: '#fff', fontWeight: 'bold', textDecoration: 'underline' }}>{com_phone}</a> <br />
        이메일: {com_email}
      </Typography>
    </Box>
  );
}

// 페이지 묶음
function Page({ type, imageSrc }) {
  return (
    <>
      {/* 페이지별 컨텐츠 */}
      {(type === 'text_cleaning') && (
        <TaxPage type={type} />
      )}

      {/* 공통 영역 */}
      <Container sx={{ mb: 8 }}>
        <img src={imageSrc} alt="메인" style={{ width: '100%' }} />
      </Container>
      <Whereweare />
      {/* ✅ Footer 높이만큼 여백 */}
      <Box
        sx={{
          height: {
            xs: '50px',   // 모바일
            sm: '50px',    // 태블릿
            md: '80px'     // PC  (md 이상 전부 80px)
          }
        }}
      />
    </>
  );
}
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 최상단으로 부드럽게 이동
  }, [pathname]);

  return null;
}
/* =====================
   App
===================== */

export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [userInfo, setUserInfo] = useState('');

  /* ✅ EmailJS 초기화 */
  useEffect(() => {
    emailjs.init(public_email_key);
  }, []);

  /* ✅ 접속 IP 표시 */
  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => {
        setUserInfo(`
          <strong>
            ※ ${data.ip}<br/>
            원활한 서비스 제공과 부정클릭 방지를 위하여<br/>
            IP주소 및 기본정보를 확인하고 있습니다.
          </strong>
        `);
      })
      .catch(() => {
        setUserInfo(`
          <strong>
            원활한 서비스 제공 및 부정클릭 방지를 위하여<br/>
            IP주소 및 기본정보를 확인하고 있습니다.
          </strong>
        `);
      });
  }, []);

  /* ✅ 반응형 */
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  const imageSrc = isMobile ? MainImageMobile : MainImagePC;

  return (
    <Router>
      <ScrollToTop />

      {/* 상단 네비 */}
      <AppBar position="sticky" sx={{ backgroundColor: color_navigator }}>
        <Toolbar>
          <Button sx={font_toolbar} component={Link} to="/text_cleaning">
            에어컨 청소 전문
          </Button>
        </Toolbar>
      </AppBar>

      {/* ✅ 유저 정보 표시 (네비 바로 아래) */}
      <div
        style={{
          marginBottom: '3px',
          padding: '12px',
          backgroundColor: '#f4f4f4',
          fontSize: '14px',
          border: '1px solid #ddd',
          borderRadius: '6px',
          textAlign: 'center',
        }}
        dangerouslySetInnerHTML={{ __html: userInfo }}
      />

      {/* 페이지 라우팅 */}
      <Routes>
        <Route path="/" element={<Navigate to="/text_cleaning" replace />} />
        <Route
          path="/text_cleaning"
          element={<Page type="text_cleaning" imageSrc={imageSrc} />}
        />
      </Routes>

      {/* 공통 고정 */}
      <Footer />
      <KakaoLink />
      <NaverLink />
    </Router>
  );
}